import React from 'react';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as HomeIcon } from '../assets/icons/house.svg';
import { ReactComponent as BookMarkIcon } from '../assets/icons/bookmark.svg';
import { ReactComponent as GolfIcon } from '../assets/icons/golf.svg';
import { ReactComponent as TicketIcon } from '../assets/icons/ticket.svg';


function BottomNav() {
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  const handleNavigation = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        navigate('/');
        break;
      case 1:
        navigate('/annuaire');
        break;
      case 2:
        navigate('/reservations');
        break;
      case 3:
        navigate('/clubs');
        break;
      default:
        break;
    }
  };


  return (
    <BottomNavigation
      value={value}
      onChange={handleNavigation}
      showLabels
      style={{ position: 'fixed', bottom: 0, width: '100%', backgroundColor: '#CDDFDD', color: '#004C38', boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.3)',
      borderTop: '1px solid #004C38' }}>
      <BottomNavigationAction 
        label="ACCUEIL" 
        icon={<HomeIcon style={{ width: 24, height: 24, stroke: value === 0 ? '#ffffff' : '#004C38', fill: 'none', marginBottom: '6px' }} />}
        style={{ color: value === 0 ? '#ffffff' : '#004C38', backgroundColor: value === 0 ? '#004C38' : '#CDDFDD', fontFamily: 'Zuume SemiBold, sans-serif', fontWeight: 600 }} />
      <BottomNavigationAction 
        label="ANNUAIRE" 
        icon={<BookMarkIcon style={{ width: 24, height: 24, stroke: value === 1 ? '#ffffff' : '#004C38', fill: 'none', marginBottom: '6px' }} />}
        style={{ color: value === 1 ? '#ffffff' : '#004C38', backgroundColor: value === 1 ? '#004C38' : '#CDDFDD', fontFamily: 'Zuume SemiBold, sans-serif', fontWeight: 600 }} />
      <BottomNavigationAction 
        label="RESERVATIONS" 
        icon={<TicketIcon style={{ width: 24, height: 24, stroke: value === 2 ? '#ffffff' : '#004C38', fill: 'none', marginBottom: '6px' }} />}
        style={{ color: value === 2 ? '#ffffff' : '#004C38', backgroundColor: value === 2 ? '#004C38' : '#CDDFDD', fontFamily: 'Zuume SemiBold, sans-serif', fontWeight: 800 }} />
      <BottomNavigationAction 
        label="CLUBS" 
        icon={<GolfIcon style={{ width: 24, height: 24, stroke: value === 3 ? '#ffffff' : '#004C38', fill: 'none', marginBottom: '6px' }} />}
        style={{ color: value === 3 ? '#ffffff' : '#004C38', backgroundColor: value === 3 ? '#004C38' : '#CDDFDD', fontFamily: 'Zuume SemiBold, sans-serif', fontWeight: 600 }} />
    </BottomNavigation>
  );
}

export default BottomNav;
